import { inject, Injectable } from '@angular/core';
import { HasAccessRightPipe } from '../pipes/has-access-right/hasAccessRight.pipe';
import { CanActivateChild, Router } from '@angular/router';
import { ESiteContext, EUserRight } from '@web/dtos';
import { ERoute } from '../constants/routes.enum';
import { AuthProviderFactory } from '../services/auth/auth-provider.factory';
import { SiteContextService } from '../services/site-context/site-context.service';

@Injectable({
  providedIn: 'root',
})
export class UserIsCmsUserGuard implements CanActivateChild {
  private readonly hasAccessRight: HasAccessRightPipe =
    inject(HasAccessRightPipe);
  private authFactory: AuthProviderFactory = inject(AuthProviderFactory);
  private siteContextService: SiteContextService = inject(SiteContextService);
  private readonly router: Router = inject(Router);

  async canActivateChild(): Promise<boolean> {
    this.siteContextService.setContext(ESiteContext.Cms);
    const auth = this.authFactory.getProvider('cms');

    try {
      await auth.initialize();
    } catch {
      return false;
    }

    if (auth.isLoggedIn()) {
      if (
        this.hasAccessRight.transform(EUserRight.CmsUser) ||
        this.hasAccessRight.transform(EUserRight.CmsAdmin)
      ) {
        return true;
      }
      this.router.navigate([`/${ERoute.accessDenied}`]);
      return false;
    } else {
      auth.login();
      return false;
    }
  }
}
